var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleCoverage',{attrs:{"title":_vm.title,"bodytext":_vm.bodytext,"link":_vm.link,"list":_vm.list,"most-popular-text":_vm.mostPopularText}})
}
var staticRenderFns = []

export { render, staticRenderFns }